import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, inject, Input, OnInit, Output } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { IonicSelectableComponent } from 'ionic-selectable'
import { OaCoordinator } from '../../../models/oaCoordinator'
import { OaCoordinatorService } from '../../../services/domain/keyCoordinator/oa-coordinator.service'

@Component({
  selector: 'app-coordinator-dropdown',
  standalone: true,
  imports: [CommonModule, FormsModule, IonicSelectableComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './coordinator-dropdown.component.html',
  styleUrls: ['./coordinator-dropdown.component.scss'],
})
export class CoordinatorDropdownComponent implements OnInit {
  private service = inject(OaCoordinatorService)

  @Input() title = ''

  @Output() changed = new EventEmitter<OaCoordinator>()

  selectedUser: OaCoordinator

  coordinators$ = this.service.getAll()

  ngOnInit(): void {
    this.changed.emit(null)
  }
}
